var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import styles from './StyledTableContainer.module.scss';
export function StyledTableContainer(_a) {
    var children = _a.children, headCellPaddingX = _a.headCellPaddingX, containerClassName = _a.containerClassName;
    return (_jsx(TableContainer, __assign({ className: containerClassName !== null && containerClassName !== void 0 ? containerClassName : styles.tableContainer }, { children: _jsx(Table, __assign({ stickyHeader: true, sx: {
                th: {
                    padding: "16px ".concat(headCellPaddingX !== null && headCellPaddingX !== void 0 ? headCellPaddingX : 16, "px !important"),
                },
            } }, { children: children })) })));
}
